import { Link, Route, Routes, useLocation } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import TenantSetup from './pages/TenantSetup';
import RunJob from './pages/RunJob';
import JobsList from './pages/JobsList';
import Templates from './pages/Templates';
import Mappings from './pages/Mappings';
import AiMapping from './pages/AiMapping';

export default function App() {
  const loc = useLocation();
  const nav = [
    { href: '/', label: 'ダッシュボード' },
    { href: '/setup', label: 'テナント設定' },
    { href: '/run', label: 'ジョブ実行' },
    { href: '/jobs', label: 'ジョブ履歴' },
    { href: '/templates', label: 'テンプレート' },
    { href: '/mappings', label: 'マッピング' },
    { href: '/ai', label: 'AIマッピング支援' },
  ];

  return (
    <div className="min-h-screen flex">
      <aside className="w-60 bg-slate-900 text-slate-100 p-4">
        <h1 className="text-lg font-bold mb-1">Bcart Connect Hub</h1>
        <p className="text-xs text-slate-400 mb-6">v0.1 (PoC)</p>
        <nav className="space-y-1">
          {nav.map((n) => (
            <Link
              key={n.href}
              to={n.href}
              className={`block px-3 py-2 rounded text-sm transition ${
                loc.pathname === n.href
                  ? 'bg-blue-600 text-white'
                  : 'text-slate-300 hover:bg-slate-800'
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
      </aside>
      <main className="flex-1 p-8 max-w-5xl">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/setup" element={<TenantSetup />} />
          <Route path="/run" element={<RunJob />} />
          <Route path="/jobs" element={<JobsList />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/mappings" element={<Mappings />} />
          <Route path="/ai" element={<AiMapping />} />
        </Routes>
      </main>
    </div>
  );
}
